

function reducer(state = {}, action){

  if (action.type == 'ADD_FILE'){
    const { file } = action.payload
    state = Object.assign({}, state)
    state[file.id] = file
  }

  if (action.type == 'UPDATE_FILE_CONTENT'){
    const { fileId, text } = action.payload
    state = Object.assign({}, state)
    state[fileId] = Object.assign({}, state[fileId])
    state[fileId].text = text
  }

  return state
}

export default reducer


// WEBPACK FOOTER //
// ./src/store/files/reducer.js